import * as React from 'react'

import moment from 'moment'
import { getDurationBetweeenDates, formatDateTime } from 'app/common/dateHelper'
import { BaseEventModel } from 'app/models/baseEventModel'
import { TooltipLayout } from './ToolTipLayout'

type EventTooltipProps = {
  event: BaseEventModel
  translate: (text) => any
}
type EventTooltipState = {}

export class EventTooltip extends React.Component<
  EventTooltipProps,
  EventTooltipState
> {
  constructor(props: EventTooltipProps) {
    super(props)
  }

  render() {
    const { startTime, endTime, typeName, color, hideDuration, info } =
      this.props.event

    const rows = []

    if (info) {

      rows.push({
        title: this.props.translate('event.duration'),
        value: info,
      })
    } else if (!hideDuration) {
      rows.push({
        title: this.props.translate('event.duration'),
        value: getDurationBetweeenDates(
          moment(startTime).toDate(),
          moment(endTime).toDate(),
        ),
      })
    }

    rows.push({
      title: this.props.translate('event.startTime'),
      value: formatDateTime(startTime),
    })

    rows.push({
      title: this.props.translate('event.endTime'),
      value: formatDateTime(endTime),
    })

    return (
      <TooltipLayout
        headerColor={color}
        headerTitle={this.props.translate(typeName).toString()}
        rows={rows}
      />
    )
  }
}
